import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import IndustriesHeader from './components/IndustriesHeader';
import IndustriesIntro from './components/IndustriesIntro';
import HomeServicesSection from './components/HomeServicesSection';
import SolarSection from './components/SolarSection';
import BeforeAfterSection from './components/BeforeAfterSection';
import IndustriesCTA from './components/IndustriesCTA';

export default function IndustriesPage() {
  return (
    <div className="font-inter">
      <Navbar />
      <main>
        <IndustriesHeader />
        <IndustriesIntro />
        <HomeServicesSection />
        <SolarSection />
        <BeforeAfterSection />
        <IndustriesCTA />
      </main>
      <Footer />
    </div>
  );
}
